import React from 'react';
import PropTypes from 'prop-types';
import { GeckoIcon } from 'ui';

import './index.scss';

const ReorderArrowControls = ({ onUp, onDown, upDisabled, downDisabled }) => {
  return (
    <div className="ReorderArrowControls">
      <button onClick={onUp} className="up" disabled={upDisabled}>
        <GeckoIcon icon="far fa-arrow-up" />
      </button>
      &nbsp;
      <button onClick={onDown} className="down" disabled={downDisabled}>
        <GeckoIcon icon="far fa-arrow-down" />
      </button>
    </div>
  );
};

ReorderArrowControls.propTypes = {
  onUp: PropTypes.func.isRequired,
  onDown: PropTypes.func.isRequired,
  upDisabled: PropTypes.bool,
  downDisabled: PropTypes.bool,
};

ReorderArrowControls.defaultProps = {
  upDisabled: false,
  downDisabled: false,
};

export default ReorderArrowControls;
